// Types pour le système d'abonnement SaaS

export enum CorpsMetier {
  CARRELEUR = 'CARRELEUR',
  PLOMBIER = 'PLOMBIER',
  ELECTRICIEN = 'ELECTRICIEN',
  MACON = 'MACON',
  PEINTRE = 'PEINTRE',
  GENERAL = 'GENERAL',
}

export const CORPS_METIER_LABELS: Record<CorpsMetier, string> = {
  [CorpsMetier.CARRELEUR]: 'Carreleur',
  [CorpsMetier.PLOMBIER]: 'Plombier',
  [CorpsMetier.ELECTRICIEN]: 'Électricien',
  [CorpsMetier.MACON]: 'Maçon',
  [CorpsMetier.PEINTRE]: 'Peintre',
  [CorpsMetier.GENERAL]: 'Multi-métiers',
};

export enum SubscriptionTier {
  ESSENTIEL = 'ESSENTIEL',
  PREMIUM = 'PREMIUM',
}

export enum BillingCycle {
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
}

export const TIER_LABELS: Record<SubscriptionTier, string> = {
  [SubscriptionTier.ESSENTIEL]: 'Essentiel',
  [SubscriptionTier.PREMIUM]: 'Premium',
};

export const BILLING_CYCLE_LABELS: Record<BillingCycle, string> = {
  [BillingCycle.MONTHLY]: 'Mensuel',
  [BillingCycle.YEARLY]: 'Annuel',
};

export interface SubscriptionStatus {
  hasActiveAccess: boolean;
  subscriptionActive: boolean;
  subscriptionEndDate: string | null;
  isInTrialPeriod: boolean;
  trialEndDate: string | null;
  stripeCustomerId: string | null;
  subscriptionDaysRemaining: number | null;
  subscriptionTier?: SubscriptionTier; // Niveau d'abonnement (ESSENTIEL ou PREMIUM)
  billingCycle?: BillingCycle; // Cycle de facturation (MONTHLY ou YEARLY)
}

export interface CheckoutSessionResponse {
  checkoutUrl: string;
  sessionId?: string;
  message: string;
}

export interface CustomerPortalResponse {
  portalUrl: string;
  message: string;
}

export interface StripePublicKeyResponse {
  publicKey: string;
}

export interface CanSubscribeResponse {
  canSubscribe: boolean;
  hasActiveAccess: boolean;
  isInTrialPeriod: boolean;
  trialEndDate: string | null;
  subscriptionEndDate: string | null;
}
